import React from 'react';

export const AdultsOnlyMaleMasturbationIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M43.26 33.18L46.98 27.66L23.82 12.04C22.26 11 20.14 11.36 19.12 12.86C18.1 14.4 18.56 16.5 20.16 17.58L43.28 33.18H43.26Z"
        fill="#FFDD67"
      />
      <path
        d="M19.0999 12.88C18.9799 13.06 18.8999 13.24 18.8199 13.42C19.9199 12.3 21.7599 12.1 23.1399 13.04L46.2999 28.66L46.9599 27.68L23.7999 12.06C22.2399 11.02 20.1199 11.38 19.0999 12.88Z"
        fill="#EBA352"
      />
      <path
        d="M41.5 39.6401L44.56 32.4201L16.68 20.6201C14.58 19.7201 12.18 20.6201 11.34 22.6201C10.5 24.6201 11.52 26.9601 13.62 27.8601L41.5 39.6601V39.6401Z"
        fill="#FFDD67"
      />
      <path
        d="M11.32 22.6001C11.24 22.7801 11.2 22.9801 11.14 23.1601C12.16 21.5401 14.28 20.8801 16.2 21.6801L44.08 33.4801L44.54 32.4001L16.66 20.6001C14.56 19.7001 12.16 20.6001 11.32 22.6001Z"
        fill="#EBA352"
      />
      <path
        d="M39.74 43.4599L40.74 36.6999L12.52 32.5799C10.54 32.2999 8.72003 33.5799 8.46003 35.4399C8.18003 37.3199 9.56003 39.0599 11.54 39.3599L39.76 43.4799L39.74 43.4599Z"
        fill="#FFDD67"
      />
      <path
        d="M8.46005 35.4199C8.44005 35.6199 8.42005 35.8199 8.44005 36.0199C8.96005 34.4799 10.6 33.4799 12.36 33.7399L40.58 37.8599L40.76 36.6999L12.54 32.5799C10.56 32.2999 8.76005 33.5799 8.48005 35.4399L8.46005 35.4199Z"
        fill="#EBA352"
      />
      <path
        d="M11.38 46.8199C11.5 48.5799 13.08 49.8399 14.92 49.7199L39.36 48.0999L38.96 41.8799L14.52 43.4999C12.68 43.6199 11.26 45.0799 11.38 46.8399V46.8199Z"
        fill="#FFDD67"
      />
      <path
        d="M11.38 46.8201C11.38 47.0201 11.44 47.2201 11.48 47.4001C11.68 45.9201 12.96 44.7601 14.6 44.6601L39.04 43.0401L38.96 41.8601L14.52 43.4801C12.68 43.6001 11.26 45.0601 11.38 46.8201Z"
        fill="#EBA352"
      />
      <path
        d="M42.12 24.86C42.06 25.04 42 25.2 41.92 25.38L38.76 24.04C38.76 24.04 31.86 28.08 28.88 40.7C28.88 40.7 26.98 47.8 30.46 49.26C30.46 49.26 38.5 54 44.84 53.9C53.38 53.76 62.1 39.78 55.54 28.62C50.94 29.46 47.04 26.78 42.1 24.84L42.12 24.86Z"
        fill="#FFDD67"
      />
      <path
        d="M27.9201 56.8399C19.8001 56.8399 13.1801 50.2199 13.1801 42.0999C13.1801 33.9799 19.8001 27.3599 27.9201 27.3599C36.0401 27.3599 42.6601 33.9799 42.6601 42.0999C42.6601 50.2199 36.0401 56.8399 27.9201 56.8399ZM27.9201 35.3599C24.2001 35.3599 21.1801 38.3799 21.1801 42.0999C21.1801 45.8199 24.2001 48.8399 27.9201 48.8399C31.6401 48.8399 34.6601 45.8199 34.6601 42.0999C34.6601 38.3799 31.6401 35.3599 27.9201 35.3599Z"
        fill="#007FB5"
      />
      <path d="M31.92 10.8H23.92V31.36H31.92V10.8Z" fill="#007FB5" />
      <path
        d="M36.2201 23.44L27.9201 16.14L19.6201 23.44L14.3401 17.42L27.9201 5.47998L41.5201 17.42L36.2201 23.44Z"
        fill="#007FB5"
      />
      <path
        d="M28.88 57.8198C20.76 57.8198 14.14 51.1998 14.14 43.0798C14.14 34.9598 20.76 28.3398 28.88 28.3398C37 28.3398 43.62 34.9598 43.62 43.0798C43.62 51.1998 37 57.8198 28.88 57.8198ZM28.88 36.3198C25.16 36.3198 22.14 39.3398 22.14 43.0598C22.14 46.7798 25.16 49.7998 28.88 49.7998C32.6 49.7998 35.62 46.7798 35.62 43.0598C35.62 39.3398 32.6 36.3198 28.88 36.3198Z"
        fill="#00A6ED"
      />
      <path d="M32.88 11.76H24.88V32.32H32.88V11.76Z" fill="#00A6ED" />
      <path
        d="M37.18 24.3999L28.88 17.0999L20.58 24.3999L15.3 18.3799L28.88 6.43994L42.48 18.3799L37.18 24.3999Z"
        fill="#00A6ED"
      />
      <path
        d="M55.56 28.62C54.84 27.42 54.02 26.22 52.92 25.1C51.9 24.06 51.12 22.8 50.44 21.52C49.92 20.54 49.5 19.48 48.68 18.72C46.72 16.92 44.36 15.28 42.12 13.86C41.02 13.16 39.78 12.7 38.56 12.22C37.72 11.88 36.4 11.1 35.54 11.8C34.62 12.54 34.78 13.94 35.06 14.94C35.4 16.2 36 17.08 36.94 17.96C37.58 18.56 38.32 19.08 39.08 19.52C39.84 19.96 40.54 20.58 41.22 21.12C42.08 21.8 42.82 23.78 42.12 24.82C44.34 25.82 46.6 26.86 48.88 27.72C51.02 28.52 53.28 29.02 55.56 28.6V28.62Z"
        fill="#FFDD67"
      />
      <path
        d="M40.18 13.4601C40.82 13.8201 41.5 14.0401 42.14 14.4201C42.8 14.8201 43.46 15.1401 44.06 15.6201C44.62 16.1001 45.2 16.5601 45.82 16.9401C46.06 17.0801 47.24 17.7201 47.24 18.0201C48.16 18.7201 48.56 20.3201 49.06 21.3201C49.82 22.8401 50.66 24.3201 51.86 25.5401C61.54 35.4601 55.48 49.7001 47.54 53.4201C56 50.5801 63.06 35.4801 52.96 25.1001C51.9 24.0201 51.1 22.7001 50.42 21.3601C50.02 20.6001 49.8 19.7601 49.42 19.0001C48.98 18.1201 48.44 17.8401 47.72 17.2601C45.94 15.8001 44.08 14.6001 42.02 13.5401C41.28 13.1601 40.4 12.8801 39.7 12.4401C38.78 11.8401 37.78 10.8601 36.62 10.8001C36 10.7801 35.36 11.0001 34.96 11.4601C34.56 11.9001 34.38 12.5001 34.36 13.0801C34.26 15.3001 35.2 17.0401 36.96 18.3801C37.72 18.9601 38.94 19.6001 39.8 20.0201C38.8 19.3001 37.34 18.3401 36.6 17.3601C36.2 16.8401 35.94 16.3001 35.72 15.7001C35.22 14.3401 34.74 13.1601 35.9 11.9201C36.1 11.7201 36.34 11.5401 36.62 11.5001C36.8 11.5001 36.98 11.5401 37.14 11.6001C37.74 11.8001 38.46 12.0401 38.96 12.4201C39.38 12.7601 39.68 13.1401 40.18 13.4001V13.4601Z"
        fill="#EBA352"
      />
      <path
        d="M42.26 24.5C38.3 28.72 37.94 39 47.38 41.54C39.02 38 40.16 29.54 41.92 25.36C42.14 24.86 42.24 24.48 42.24 24.48L42.26 24.5Z"
        fill="#EBA352"
      />
    </svg>
  );
};
